module.exports = __webpack_public_path__ + "static/developer-step2.e094b4d2.png";